import React from "react";

function Section({ title, children }) {
  return (
    <section className="mt-8">
      <h2 className="text-lg font-bold">{title}</h2>
      <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-600">
        {children}
      </div>
    </section>
  );
}

export default function Terms() {
  return (
    <div className="section-container max-w-3xl py-16">
      <h1 className="text-3xl font-bold sm:text-4xl">Terms & Conditions</h1>
      <p className="mt-2 text-sm text-slate-500">Last updated: May 20, 2026</p>

      <p className="mt-6 text-sm leading-relaxed text-slate-600">
        These Terms & Conditions govern your use of Money Flow Accounting accounting
        software and services. By accessing or using Money Flow Accounting, you agree to
        be bound by these terms.
      </p>

      <Section title="1. Acceptance of Terms">
        <p>
          By creating an account or using Money Flow Accounting, you agree to these Terms
          & Conditions and our Privacy Policy. If you do not agree, you may
          not use our services.
        </p>
      </Section>

      <Section title="2. Description of Service">
        <p>
          Money Flow Accounting provides cloud-based accounting software and related
          services for businesses, including invoicing, expense tracking, bank
          reconciliation, reporting, and payroll tools.
        </p>
      </Section>

      <Section title="3. User Accounts">
        <p>
          You are responsible for maintaining the security of your account and
          for all activities under your account. You must provide accurate and
          complete information when registering and keep it up to date.
        </p>
      </Section>

      <Section title="4. Subscription and Payment">
        <ul className="list-disc space-y-2 pl-5">
          <li>
            Subscription fees are billed in advance on a monthly or annual
            basis.
          </li>
          <li>All fees are non-refundable except as required by law.</li>
          <li>
            We reserve the right to change pricing with 30 days' notice.
          </li>
        </ul>
      </Section>

      <Section title="5. Acceptable Use">
        <p>
          You agree not to use our services for any unlawful purpose or in any
          way that could damage, disable, or impair our platform, or interfere
          with any other party's use of the services.
        </p>
      </Section>

      <Section title="6. Limitation of Liability">
        <p>
          Money Flow Accounting is not liable for any indirect, incidental, or
          consequential damages arising from your use of our services. Our
          total liability shall not exceed the amount you paid in the twelve
          months preceding the claim.
        </p>
      </Section>

      <Section title="7. Termination">
        <p>
          We reserve the right to suspend or terminate your account if you
          violate these terms. You may cancel your subscription at any time
          from your account settings.
        </p>
      </Section>

      <Section title="8. Contact Us">
        <p>
          If you have any questions about these Terms & Conditions, please
          contact us at{" "}
          <a
            href="mailto:legal@accountrix.com"
            className="font-medium text-primary hover:underline"
          >
            legal@accountrix.com
          </a>
          .
        </p>
      </Section>
    </div>
  );
}
